// const Store = require("electron-store");

// const store = new Store();

// 说明：
// - token 用 localStorage：避免“注册/登录后刷新页面或系统回收 WebView 就自动掉线”的体验
// - 其它临时数据仍用 sessionStorage：关页面就清，避免脏数据长期残留
const pickStorage = (key) => (key === "token" ? localStorage : sessionStorage);

const store = {
  set: function (key, value) {
    return pickStorage(key).setItem(key, value);
  },
  get: function (key) {
    return pickStorage(key).getItem(key);
  },
  delete: function (key) {
    return pickStorage(key).removeItem(key);
  },
};

export default store;
